import cn from "classnames";
import tileStyles from "../FolderTile/FolderTile.module.css";
import { IconFolderPlus } from "src/components/ui-components/Icons/IconFolderPlus";
import { Modal } from "src/components/ui-components/Modal/Modal";
import { useActiveContext } from "shared/ContextSwitcher/store";
import { CreateFolderDialogContent } from "./CreateFolderDialogContent";
import { AnchorButton } from "src/components/ui-components/Button/AnchorButton";
import { Tooltip } from "src/components/ui-components/Tooltip/Tooltip";

interface Props {
  refetchFolders: () => Promise<void>;
  foldersCount: number;
}

export function NewFolderTile(props: Props) {
  const activeContext = useActiveContext();

  if (!activeContext) {
    return null;
  }

  const serviceTierMaxFolders = activeContext.serviceTier.maxFolders ?? 0;
  const isFolderLimitReached = props.foldersCount >= serviceTierMaxFolders;

  return (
    <Modal
      size="M"
      label="Create folder"
      content={({ close }) => (
        <CreateFolderDialogContent
          onDismiss={close}
          refetchFolders={props.refetchFolders}
          owner={activeContext}
        />
      )}
      trigger={({ onClick }) => (
        <Tooltip
          hidden={!isFolderLimitReached}
          label="You've reached the folder limit included in your plan."
          position="below-center"
        >
          <button
            className={cn(
              tileStyles.tile,
              tileStyles.tiny,
              tileStyles.dashed,
              isFolderLimitReached && tileStyles.disabled
            )}
            style={
              {
                "--customColor": "var(--feedback--accent--neutral)",
              } as React.CSSProperties
            }
            onClick={onClick}
            disabled={isFolderLimitReached}
          >
            <div
              className={cn(
                tileStyles.content,
                tileStyles.tiny,
                isFolderLimitReached && tileStyles.disabled
              )}
            >
              <div className={cn(tileStyles.content, tileStyles.tiny)}>
                <div className={tileStyles.folderIcon}>
                  <IconFolderPlus />
                </div>
                <div className={tileStyles.folderDetails}>
                  <h1 className={tileStyles.folderName}>New Folder</h1>
                </div>
              </div>
              {isFolderLimitReached && (
                <AnchorButton
                  className={tileStyles.upgradeButton}
                  size="S"
                  theme="secondary"
                  href="/pricing"
                >
                  Upgrade
                </AnchorButton>
              )}
            </div>
          </button>
        </Tooltip>
      )}
    />
  );
}
